import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { FiEye, FiEyeOff } from 'react-icons/fi';

type PasswordVisibilityToggleProps = {
  isVisible: boolean;
  onToggle: () => void;
  className?: string;
  inputId: string;
};

const PasswordVisibilityToggle: FC<PasswordVisibilityToggleProps> = ({
  isVisible,
  onToggle,
  className,
  inputId,
}) => {
  const { t } = useTranslation();

  return (
    <button
      type='button'
      tabIndex={-1}
      aria-controls={inputId}
      aria-pressed={isVisible}
      aria-label={t(isVisible ? 'AuthLayout.hidePassword' : 'AuthLayout.showPassword')}
      onPointerDown={(event) => {
        event.preventDefault();
        event.stopPropagation();
        onToggle();
      }}
      className={classNames(
        'flex items-center justify-center text-[#748194] bg-transparent border-0 p-0 cursor-pointer',
        className,
      )}
    >
      {isVisible ? <FiEye size={16} /> : <FiEyeOff size={16} />}
    </button>
  );
};

export default PasswordVisibilityToggle;
